export default "__VITE_ASSET__BGR$hxDe__"